import React from 'react'
import { Skill } from '../../../interfaces/Skill'
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface AccordianItemProps {
	skill: Skill;
	toggleAccordian: (id: number) => void;
	selected: number;
}

const AccordianItem: React.FC<AccordianItemProps> = ({ skill, toggleAccordian, selected }) => {

	return (
		<div className={`skills-item skills-container-col accordian-cursor`}>
			<div
				className='title'
				onClick={() => toggleAccordian(skill.id)}
			>
				<h3>{skill.skillName}</h3>
				<div className='ai-icon-box'>
					<FontAwesomeIcon className={`rotate-icon ${selected === skill.id && 'up'}`} icon={faAngleDown} />
				</div>
			</div>
			<div className={`content ${(selected === skill.id) && 'show'}`}>
				<ul>
					{skill.skillDetails.map((detail) => {
						return <li className='accordian-detail-item' key={detail.id}>
							<div>
								<FontAwesomeIcon className='ai-list-icon' icon={faAngleRight} />
								&nbsp;
								{detail.data}
							</div>
						</li>
					})}
				</ul>
			</div>
		</div>
	)
}

export default AccordianItem;